const apis = {
  AuthAPI: 'AuthAPI',
  UserAPI: 'UserAPI',
  ExportAPI: 'ExportAPI',
  SocialAPI: 'SocialAPI',
  TeacherAPI: 'TeacherAPI',
  StudentAPI: 'StudentAPI',
  GoogleDriveAPI: 'GoogleDriveAPI',
  ParentAPI: 'ParentAPI',
  CommonAPI: 'CommonAPI',
  ConvertAPI: 'ConvertAPI',
  MISAStoreAPI: 'MISAStoreAPI',
  FileAPI: 'FileAPI',
  NewsFeedAPI: 'NewsFeedAPI'
}

const getApiUrl = (api) => {
  return window.__env.api[api]
}

export { apis, getApiUrl }
